export default __webpack_public_path__ + "static/media/withdrawmodaltick.36c6ad55.svg";